import { createAction } from '@reduxjs/toolkit';
import { IAuthDwhData, ISearchRadarData, IToolbarActionAnalyticsParams } from 'reactApp/modules/dwh/dwh.types';

export const sendAuthDwhRequest = createAction<IAuthDwhData>('dwh/sendAuthDwhRequest');
export const dispatchSearchRadar = createAction<ISearchRadarData>('dwh/dispatchSearchRadar');
export const dispatchSearchRadarToolbarAction = createAction<IToolbarActionAnalyticsParams>('dwh/dispatchSearchRadarToolbarAction');
